export const isLoading = state => state.isLoading;
export const snackbarInfo = state => state.snackbarInfo;
export const sidebarIsShow = state => state.sidebar.isShow;
export const getItemsTable = state => state.itemsTable;
export const getHasLoggedUser = state => state.hasLoggedUser;
